import { c as _c } from "react/compiler-runtime";
import { FaroSelect } from "@components/common/faro-select/faro-select";
import { MenuItem } from "@flat-ui";
import { FaroTextField } from "@components/common/faro-text-field/faro-text-field";
import { PageInfoBar } from "@components/common/page-info-bar";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { QueryParams } from "@router/route-params";
import { selectedAnalyticsTimeFrameSelector } from "@store/analytics/analytics-selector";
import { selectedSdbCompanyNameSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { TIME_FRAMES } from "@utils/time-utils";

/**
 * Shows the analytics bar with project and date range
 */
export function AnalyticsInfoBar() {
  const $ = _c(11);
  const selectedAnalyticsTimeFrame = useAppSelector(selectedAnalyticsTimeFrameSelector);
  const selectedSdbCompanyName = useAppSelector(selectedSdbCompanyNameSelector);
  const {
    setUrlParam
  } = useAppNavigation();
  const t0 = selectedSdbCompanyName ?? "";
  let t1;
  if ($[0] !== t0) {
    t1 = {
      content: <FaroTextField label={<var>{t0}</var>} initialValue="Includes all projects from this workspace" faroVariant="main" fontSize="18px" shouldShowTooltip={true} />
    };
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== setUrlParam) {
    t2 = value => {
      setUrlParam({
        key: QueryParams.timeFrame,
        value: value.toString()
      });
    };
    $[2] = setUrlParam;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = TIME_FRAMES?.map(_temp);
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== selectedAnalyticsTimeFrame || $[6] !== t2) {
    t4 = {
      content: <FaroSelect shouldShowFullWidth={true} label="Activity History" variant="standard" value={selectedAnalyticsTimeFrame} onChange={t2}>{t3}</FaroSelect>
    };
    $[5] = selectedAnalyticsTimeFrame;
    $[6] = t2;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t1 || $[9] !== t4) {
    t5 = <PageInfoBar items={[t1, t4]} />;
    $[8] = t1;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
}
function _temp(timeFrame, index) {
  return <MenuItem key={`menu-item-${index}`} value={timeFrame.value}>{timeFrame.label}</MenuItem>;
}